/**
 * API服务 - 兼容层
 * 实际代码已拆分至 api/ 子目录
 * 保留此文件以确保现有导入不会崩溃
 */

// 导出客户端
import apiClient from './api/client';
export default apiClient;
export { default as api } from './api/client';

// 导出各模块 API
export { skuAPI } from './api/skuAPI';
export { periodAPI, weightConfigAPI } from './api/periodAPI';
export { keywordAPI, competitorAPI, skuGroupAPI, metricsDefinitionAPI } from './api/keywordAPI';
export { trendAPI, brandNetworkAPI, asinTrajectoryAPI, marketShiftAPI } from './api/trendAPI';
export { keywordSearchAPI, listingCheckAPI, amazonOrderAPI } from './api/businessAPI';
